class LocationsListController {

    constructor() {
        'ngInject';
    }


    public $onInit = () => {
    }

    public $onChanges = () => {
    
    }
}

export const locationsListComponent = {
    bindings: {
        locations: "<"
    },
    controller: LocationsListController,
    template: require('./locations.list.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/crm/locations/locations.list.component.ts